import { useParams } from "react-router-dom";
import Table from "./Table";
import useLogs from "../hooks/useLogs";
import Pagination from "./Pagination";
import useFilter from "../hooks/useFilter";
const EmployeeActivityLog = () => {
  const { employeeId } = useParams();
  const { setFilter } = useFilter();
  const { data, error, isError, isLoading } = useLogs({ adminId: employeeId });
  return (
    <div className="bg-third rounded-3xl p-6 flex flex-col gap-5">
      <div className="flex items-center justify-between font-semibold">
        <h3>Employee Activity Log</h3>
        <button className="w-8 h-8 rounded-full bg-fifth flex items-center justify-center">
          <img src="/img/filter.svg" alt="" />
        </button>
      </div>
      <Table
        tableHeader={[
          "Action ID",
          "Action Type",
          "Action Title",
          "Action Description",
          "Action Section",
          "Date & Time",
          "Severity Level",
          "Action Result",
        ]}
        tableData={data?.data?.list}
        error={error}
        isError={isError}
        loading={isLoading}
        type="adminLogs"
      />
      <Pagination
        paginate={{
          pageNumber: data?.data?.current_page,
          totalPages: data?.data?.total_pages,
          hasNext: data?.data?.has_next,
        }}
        setFilter={setFilter}
      />
    </div>
  );
};

export default EmployeeActivityLog;
